export const environment = {
	production: false,
	stage: 'dev',
	url: 'https://portal.cancom.dev',
	keycloak: {
		url: 'https://sso.cancom.dev/auth/',
		realm: 'cancom-dev',
		clientId: 'reports.cc-mase-automation.de',
	},
	contactEMail: 'portal@ihre-meinung-interessiert-uns.net',
	supportEMail: 'ccp-support@cancom.io',
	trackingId: 2,
	assets: 'https://portal-assets.cancom.io',
	feature: {
		subaccountsEnabled: true,
		corcAllRancherServers: false,
		s3WormsEnabled: false,
		pricingCalculator: false,
		multiLanguage: false,
	},
	docs: {
		cancom: 'https://pages.cancom.dev/docs/ccp',
		customer: 'https://docs.portal.cancom.io',
	},
	api: {
		accountManagement: 'https://myaccount-api.portal.cancom.dev',
		auditLog: 'https://audit-log.portal.cancom.dev',
		azurelz: 'https://az-landing.portal.cancom.dev',
		carRental: 'https://car-rental.portal.cancom.dev',
		cmsmgw: 'https://cmsmgw.cc-mase-interfaces.de/dev',
		cmsmgwaddons: 'https://j2xydo8d6j.execute-api.eu-central-1.amazonaws.com/dev/dev',
		corc: 'https://corc.portal.cancom.dev',
		corgy: 'https://corgy.wkcgkpcidu3qnpuz6zhjxp.capi.cancom.io',
		customerDb: 'https://customer-db.portal.cancom.dev',
		database: 'https://dbaas.portal.cancom.dev',
		configManager: 'https://config-manager.portal.cancom.dev',
		dciNg: 'https://dci-ng.portal.cancom.dev',
		drive: 'https://drive-api.portal.cancom.dev',
		eventbridge: 'https://event-bridge.portal.cancom.dev',
		genericServices: 'https://generic-services.portal.cancom.dev',
		iam: 'https://iam.portal.cancom.dev',
		ipmanagement: 'https://ip-management.portal.cancom.dev',
		managedCampus: 'https://campus-poc.cancom.dev',
		meteringEngine: 'https://metering-engine.portal.cancom.dev',
		miaMuseum: 'https://mia-museum.portal.cancom.dev',
		orderProcessing: 'https://order-processing.portal.cancom.dev',
		reportCreator: 'https://report-creator.portal.cancom.dev',
		rotationCalendar: 'https://rotation-calendar.portal.cancom.dev',
		serviceRegistry: 'https://service-registry.portal.cancom.dev',
		simpleVpn: 'https://simple-vpn.portal.cancom.dev',
		smsAlert: 'https://sms-notify.portal.cancom.dev',
		sslMonitor: 'https://ssl-monitor.portal.cancom.dev',
		terraformManagement: 'https://tf-management.portal.cancom.dev',
		s3: 'https://s3.portal.cancom.dev',
		tRex: 'https://resource-explorer.portal.cancom.dev',
		tosManager: 'https://tos-manager.portal.cancom.dev',
		webpresence: 'https://domdns2.portal.cancom.dev',
		WindowsOS: 'https://windows-os.cancom.dev',
		xaasonazure: 'https://xaas-azure.portal.cancom.dev',
		monitoringHub: 'https://mhub.portal.cancom.dev',
		managedOs: 'https://managed-server.portal.cancom.dev',
		managedEnv: 'https://managed-env.portal.cancom.dev',
		notification: '',
		firewallManagement: 'https://firewall-management.portal.cancom.dev',
	},
	external: {
		drive: 'https://drive.portal.cancom.dev',
		myaccount: 'https://myaccount.portal.cancom.dev',
		harbor: 'https://harbor.wkcgkpcidu3qnpuz6zhjxp.capi.cancom.io',
	},
	agGridLicenseKey:
		'Using_this_{AG_Grid}_Enterprise_key_{AG-096271}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{CANCOM_Managed_Services_GmbH}_is_granted_a_{Single_Application}_Developer_License_for_the_application_{CANCOM_Cloud_Portal}_only_for_{5}_Front-End_JavaScript_developers___All_Front-End_JavaScript_developers_working_on_{CANCOM_Cloud_Portal}_need_to_be_licensed___{CANCOM_Cloud_Portal}_has_been_granted_a_Deployment_License_Add-on_for_{1}_Production_Environment___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{14_February_2027}____[v3]_[01]_MTgwMjU2MzIwMDAwMA==60aa24764bff091cc19b2a7f311a3c3b',
};
